export default "__VITE_ASSET__DOyJanza__"